import { ThemeUICSSObject } from '@apia/theme';
import { form } from './form';
import { history } from './history';
import { controller } from './controller';
import { attachments } from './attachments';
import { message } from './message';
import { assistant } from './assistant';
import { attachmentPreview } from './attachmentPreview';
/* IMPORT HERE */
export const chat: ThemeUICSSObject = {
  /* PREPEND HERE */
  attachmentPreview,
  assistant,
  form,
  history,
  controller,
  attachments,
  message,
};
